
import { capitalizeText } from 'src/util/formatters/stringNormalizer';
import { getLabelFormatterByPerguntasPrincipal } from './labelFormatter';

/**
 * to singleStackChart data
 * @param data [{pesquisa, pergunta_principal:{id,enunciado,alternativas,pergunta_cruzada} }]
 */
export function toEchartData(cruzamentoSimples, chartFontSize, theme, disabledLegends = []) {
  // eslint-disable-next-line camelcase
  const { pergunta_principal } = cruzamentoSimples;

  /**
   * legendas do gráfico
   */
  const legends = pergunta_principal.alternativas
    .map((alternativa) => alternativa.enunciado);

  const categories = pergunta_principal.pergunta_cruzada.alternativas.map((alternativa) => alternativa.enunciado);

  const labelFormatter = getLabelFormatterByPerguntasPrincipal(pergunta_principal, disabledLegends);

  /**
   * cada alternativa principal eh convertida
   * para uma serie
   */
  // eslint-disable-next-line camelcase
  const series = pergunta_principal.alternativas.map((alternativa_principal) => {
    // eslint-disable-next-line camelcase
    const { pergunta_cruzada } = pergunta_principal;

    const data = pergunta_cruzada.alternativas
      // eslint-disable-next-line camelcase
      .map((alternativa_cruzada) => {
        const cruzamento = alternativa_cruzada.cruzamentos[alternativa_principal.id];
        return {
          subject: alternativa_cruzada.enunciado,
          ...cruzamento,
        };
      })
      .map((cruzamento) => ({
        subject: cruzamento.subject,
        value: cruzamento.resultado_percentual,
        numeric: cruzamento.resultado_numerico,
      }));

    return {
      name: alternativa_principal.enunciado,
      type: 'bar',
      stack: pergunta_principal.enunciado,
      label: {
        show: true,
        formatter: labelFormatter,
        textStyle: {
          fontSize: chartFontSize,
          color: theme.label.text,
          fontFamily: 'Roboto, sans-serif'
        },
        formatter: capitalizeText,
      },
      data,
    };
  });

  return {
    legends,
    categories,
    series,
  };
}
